import { render, staticRenderFns } from "./AdminOfferStateBadge.vue?vue&type=template&id=2529f575&"
import script from "./AdminOfferStateBadge.vue?vue&type=script&lang=ts&"
export * from "./AdminOfferStateBadge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports